import React from 'react';
import VirtualizedAutocomplete from '../Dropdown/VirtualizedAutocomplete'; // Adjust the path

const RenderFieldsVirtualizedAutocomplete = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  validationErrors = {},
}) => {
  const getSelectedOption = (options, fieldValue) => {
    return (
      options.find((option) => String(option.key) === String(fieldValue)) || {
        key: String(fieldValue || ''),
        value: String(fieldValue ? `(${fieldValue})` : ''),
      }
    );
  };

  return (
    <>
      {fields.map((field) => {
        const fieldValue = formData[field.key] || '';
        const isFieldReadOnly = readOnly || field.readOnly;

        if (field.options && field.options.length > 0) {
          // Handle dropdown fields
          const selectedOption = getSelectedOption(field.options, fieldValue);

          return (
            <div key={field.key} className="flex items-center w-full mb-4">
              {/* Label */}
              <div style={{ width: '200px' }}>
                <label className="font-semibold">{field.label}</label>
              </div>

              {/* Dotted Line */}
              <div style={{ width: '250px', margin: '0 10px' }}>
                <span className="block border-dotted border-b-4 border-gray-200 w-full"></span>
              </div>

              {/* Virtualized Autocomplete */}
              {/* Virtualized Autocomplete */}
              <div style={{ flexGrow: 1, width: '100%' }}>
                <VirtualizedAutocomplete
                  options={field.options.map((option) => ({
                    ...option,
                    key: String(option.key),
                    value: String(option.value),
                  }))} // Ensure keys and values are strings
                  value={selectedOption}
                  onChange={(event, newValue) => {
                    handleChange({
                      target: {
                        name: field.key,
                        value: newValue ? newValue.key : '',
                      },
                    });
                  }}
                  // Remove the `label` prop here to avoid showing a second label
                  optionKey="key"
                  optionLabel="value"
                  disabled={isFieldReadOnly}
                  error={!!validationErrors[field.key]}
                  helperText={validationErrors[field.key]}
                  fullWidth
                  style={{
                    backgroundColor: isFieldReadOnly ? '#f3f4f6' : 'white',
                    width: '100%',
                  }}
                  InputProps={{
                    className: `border ${validationErrors[field.key] ? 'border-red-500' : 'border-gray-300'
                      } p-2 rounded-md w-full`,
                  }}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    return String(option.key) === String(value.key);
                  }}
                />
              </div>

            </div>
          );
        } else {
          // Handle regular input fields
          return (
            <div key={field.key} className="flex items-center w-full mb-4">
              {/* Label */}
              <div style={{ width: '200px' }}>
                <label className="font-semibold">{field.label}</label>
              </div>

              {/* Dotted Line */}
              <div style={{ width: '100px', margin: '0 10px' }}>
                <span className="block border-dotted border-b-4 border-gray-200 w-full"></span>
              </div>

              {/* Input */}
              <div style={{ flexGrow: 1 }}>
                <input
                  type="text"
                  name={field.key}
                  className={`border ${validationErrors[field.key]
                      ? 'border-red-500'
                      : 'border-gray-300'
                    } p-2 rounded-md w-full`}
                  value={fieldValue}
                  onChange={handleChange}
                  readOnly={isFieldReadOnly}
                  style={{
                    backgroundColor: isFieldReadOnly ? '#f3f4f6' : 'white',
                  }}
                />
              </div>
            </div>
          );
        }
      })}
    </>
  );
};

export default RenderFieldsVirtualizedAutocomplete;